import A11yDialog from 'a11y-dialog';
import { onBxFormSubmit } from '../../lib/onBxFormSubmit';

export function educationInstallment(): void {
  const element = document.getElementById('education-installment-dialog');
  if (!element) return;

  const dialog = new A11yDialog(element);
  const formContainer = element.querySelector('.education-installment-dialog__form');
  const description = element.querySelector<HTMLElement>('.education-installment-dialog__text');
  const successClass = 'education-installment-dialog--success';
  let closeTimer: number | undefined;

  const hasSuccessText = () =>
    /Ваша заявка\s+\d+\s+принята/i.test(formContainer?.textContent || '');

  const isSuccessState = () =>
    Boolean(formContainer?.querySelector('.notetext')) ||
    (!formContainer?.querySelector('form') &&
      !formContainer?.querySelector('.errortext') &&
      hasSuccessText());

  const closeOnSuccess = () => {
    if (closeTimer) window.clearTimeout(closeTimer);

    closeTimer = window.setTimeout(() => {
      dialog.hide();
    }, 3000);
  };

  const setSuccessState = (isSuccess: boolean) => {
    element.classList.toggle(successClass, isSuccess);

    if (description) {
      description.hidden = isSuccess;
    }
  };

  dialog.on('show', () => {
    if (closeTimer) window.clearTimeout(closeTimer);

    setSuccessState(isSuccessState());
  });

  onBxFormSubmit('.education-installment-dialog__form', ({ isSuccess }) => {
    if (!isSuccess) return;

    setSuccessState(true);
    closeOnSuccess();
  });

  if (!formContainer) return;

  const observer = new MutationObserver(() => {
    if (isSuccessState()) {
      setSuccessState(true);
      closeOnSuccess();
    }
  });

  observer.observe(formContainer, { childList: true, subtree: true });
}
